import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const fragment = location.hash.substring(1);
        const params = new URLSearchParams(fragment);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error("No session ID found");
          navigate('/login');
          return;
        }

        const response = await axios.post(
          `${API}/auth/google/session?session_id=${sessionId}`,
          {},
          { withCredentials: true }
        );

        toast.success("Logged in successfully!");
        navigate('/dashboard', { state: { user: response.data.user } });
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("Authentication failed");
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-lime-700 border-t-transparent"></div>
        <p className="mt-4 text-stone-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;